import { ScanBarcode, ClipboardPlus, ArrowRightLeft, StickyNote, Camera } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

const ACTIONS = [
  { icon: ScanBarcode, label: 'Scan', action: 'scan' },
  { icon: ClipboardPlus, label: 'New WO', action: 'new-wo' },
  { icon: ArrowRightLeft, label: 'Move Asset', action: 'move' },
  { icon: StickyNote, label: 'Add Note', action: 'note' },
  { icon: Camera, label: 'Photo', action: 'photo' },
];

export default function BottomBar() {
  const navigate = useNavigate();

  const handleAction = (action: string) => {
    if (action === 'new-wo') navigate('/work-orders?new=1');
    // Other actions will trigger modals in later phases
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex h-16 items-center justify-around border-t border-border bg-card px-2 md:hidden">
      {ACTIONS.map((item) => (
        <button
          key={item.action}
          onClick={() => handleAction(item.action)}
          className={cn(
            'flex flex-col items-center justify-center gap-0.5 rounded-lg px-3 py-1.5 text-muted-foreground transition-colors',
            'hover:text-primary active:bg-accent'
          )}
        >
          <item.icon className="h-5 w-5" />
          <span className="text-[10px] font-medium">{item.label}</span>
        </button>
      ))}
    </div>
  );
}
